import fetch from '@api/fetchers';
import { HOST_TYPE } from '@utils/api-helper/host';
import {
  normalizeUpscSeoConfigResponse,
  UPSC_SEO_CONFIG_CMS_API_PATH
} from '@api/fetchers/upscCurrentAffairs/seoConfig';

let cachedSeoInitialProps = null;
let pendingSeoFetch = null;

const EMPTY_SEO_INITIAL_PROPS = {
  upscSeoConfig: {},
  upscSeoConfigError: true
};

const buildSeoInitialProps = (rawSeoConfig) => {
  if (!rawSeoConfig || rawSeoConfig.error) {
    return EMPTY_SEO_INITIAL_PROPS;
  }

  return {
    upscSeoConfig: normalizeUpscSeoConfigResponse(rawSeoConfig),
    upscSeoConfigError: false
  };
};

const fetchSeoInitialProps = async () => {
  const rawSeoConfig = await fetch(UPSC_SEO_CONFIG_CMS_API_PATH, {
    host: HOST_TYPE.CMS,
    useCamelCase: true,
    useAuthToken: false,
    skipLoader: true
  });

  const nextProps = buildSeoInitialProps(rawSeoConfig);

  if (!nextProps.upscSeoConfigError) {
    cachedSeoInitialProps = nextProps;
  }

  return nextProps;
};

const getUpscCurrentAffairsSeoInitialProps = async () => {
  if (cachedSeoInitialProps) {
    return cachedSeoInitialProps;
  }

  if (!pendingSeoFetch) {
    pendingSeoFetch = fetchSeoInitialProps()
      .catch(() => EMPTY_SEO_INITIAL_PROPS)
      .finally(() => {
        pendingSeoFetch = null;
      });
  }

  return pendingSeoFetch;
};

export default getUpscCurrentAffairsSeoInitialProps;
